module.exports = __webpack_public_path__ + "img/step1.315b065f.png";